<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div v-if="showBillingWarning" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden">
        <form @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full p-2">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Confirm Change in Billing</p>
            <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png" @click="close()" />
          </div>
          <div
            class="flex gap-2 form-control w-full p-3.5 mt-2 bg-gray-200 rounded-md py-1.5 text-base font-normal text-gray-700  bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none border-0.5">
            <img src="@/assets/icons/triangle-warning.svg" alt="warning">
            <p>
              {{ reason }}
            </p>
          </div>

          <!--  @change="handleDescriptionChange" -->
          <div class="flex justify-end p-5 gap-5">
            <button type="submit" class="bg-primary rounded-full px-10 text-sm text-white py-2">
              Ok
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "BillingChangeWarning",
  props: ["showBillingWarning", "setIsConfirmed"],
  components: { Loader },
  data() {
    return {
      reason: "Note that the you need to pay {Some AMOUNT} immediately. You will be charged {Orginal Amount + New Amount} from the next billing period.",
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },

    create() {
      this.setIsConfirmed()
      this.close()
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>

